import React from 'react'
import View from './view'
import {Divisions} from '../../../constants/divisions'
import {Attempt} from '../../../redux/reportExamStatus'

type Props = {
  division: Divisions
  dateFilter: string
  onChangeDateFilter: (
    value: string,
    courseId?: string,
    attemptId?: string,
  ) => void
  reportStatus?: Attempt
  courseId?: string
}

const DivisionDatepicker = ({
  division,
  dateFilter,
  onChangeDateFilter,
  reportStatus,
  courseId,
}: Props) => {
  return (
    <View
      division={division}
      dateFilter={dateFilter}
      onChangeDateFilter={onChangeDateFilter}
      reportStatus={reportStatus}
      courseId={courseId}
    />
  )
}

export default DivisionDatepicker
